<template>
<div>
    <email-filters @filter="filter"></email-filters>
    <table class="table">
        <tr>
            <th>
                E-mail
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'email'" :direction="meta.direction"></sorting>

            </th>
            <th>
              Status
              <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'status'" :direction="meta.direction"></sorting>
            </th>
            <th>
                Zaimportowany
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'was_imported'" :direction="meta.direction"></sorting>
            </th>
            <th>
                Akcje
            </th>
        </tr>
        <tr v-for="item in items">
            <td>
                <a class="main-link" @click="$router.push({name: 'admin.emails.show', params: {id: item.id}})">{{ item.email }}</a>
            </td>
            <td>
              <email-status :item="item" v-if="item"></email-status>
            </td>
            <td>
              <div v-if="item.was_imported">
                <span class="label-black">Tak.</span> <span class="label">{{ item.imported_at_formated }}</span>
              </div>
                <div v-if="!item.was_imported">
                  <span class="label"></span>
                </div>
            </td>
            <td class="actions">
                <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.emails.edit', params: {id: item.id}})">Edytuj</ui-button>
                <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
            </td>
        </tr>
    </table>
    <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>

</template>
<script>
import EventEmitter from './../../services/EventEmitter'
import Emails from './../../services/Emails'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  methods: {
    getService () {
      return Emails
    },
    _remove (item) {
      Emails.remove(item.id).then(res => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    },
    filter (filters) {
      this.meta.filter = filters
      this.meta.current_page = 1
      this.reload()
    }
  }
}
</script>


// WEBPACK FOOTER //
// List.vue?2b3f6093